export const DEFAULT_RT_SEARCHES_RANGE = 30;
